import { render } from "./LocaleSelect.vue?vue&type=template&id=55c22700&scoped=true"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"

import "./LocaleSelect.vue?vue&type=style&index=0&id=55c22700&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c22700"]])

export default __exports__